/* =============================================================================
   CORE / EDGE-MAIL-HELPERS — JS-Mirror der process-mail-outbox Pure-Helpers
   =============================================================================
   Session 76 (S76-Pre, Test-Schicht C — Memory `gg-test-coverage-matrix`)
   ----------------------------------------------------------------------------
   Die Receipt-/Confirmation-Mail-Betraege werden in der Deno-Edge-Function
   `supabase/functions/process-mail-outbox/index.ts` (v31) berechnet. Deren
   Pure-Helpers laufen sonst NUR live — kein Vitest fasst sie an, also kann ein
   Cent-Bug (S74-Befund: Items zeigten `0,00 EUR`) erst im Outlook auffallen.

   Dieses Modul ist ein 1:1-JS-Spiegel der Edge-Function-Helpers
   `lineTotalToCents` / `itemLineCents` / `centsToEur` (index.ts Z. 39/91/96).

   Konsumenten (S77-A):
   - `edge-mail-helpers.test.js` — Vitest-Abdeckung der Pure-Helpers.
   - `src/utils/helpers.js` `normalizePreorderItems()` — der JS-Direct-Send-Pfad
     der Receipt-Mails (`dispatch_source='direct'`) umgeht die Edge-Function;
     er nutzt `lineTotalToCents`, damit er Beträge IDENTISCH zum Queue-Pfad
     auflöst (sonst zeigten snake-Cents-Snapshots `0,00 €`, S76-Befund).

   WICHTIG (Memory `gg-edge-function-source-drift`):
   Bei jeder Edge-Function-Aenderung an einem dieser Helper MUSS dieser Spiegel
   nachgezogen werden, sonst driftet er gegen die Live-Logik. Die maßgebliche
   Quelle bleibt index.ts — dieser Spiegel folgt ihr, nie umgekehrt.

   Spiegel-Stand: process-mail-outbox v32 (S76 — Helpers unverändert ggü. v31,
   v32 ergänzte nur buildTrackingLink/tracking_link).
   ============================================================================= */

// Mirror von index.ts Z.91:
// Akzeptiert sowohl Snake-Cent-Werte (Integer >= 100) als auch Euro-Floats und
// normalisiert beide auf Cents. <=0 / NaN / nicht-finite → 0.
export function lineTotalToCents(v) {
  const n = Number(v);
  if (!Number.isFinite(n) || n <= 0) return 0;
  if (Number.isInteger(n) && n >= 100) return n;
  return Math.round(n * 100);
}

// Mirror von index.ts Z.96:
// Resolver für die Zeilensumme einer Position in Cents. Deckt drei Feldformate
// ab — `lineTotal` (camelCase-Euro), `line_total_cents` (alt Customer-Form),
// `line_total` (snake-Cents aus order_items). Fallback: unit_price * qty.
export function itemLineCents(it) {
  const item = it || {};
  const direct = lineTotalToCents(item.lineTotal ?? item.line_total_cents ?? item.line_total);
  if (direct > 0) return direct;
  const unitCents = lineTotalToCents(item.unitPrice ?? item.unit_price);
  const qty = Number(item.qty ?? item.quantity ?? 1) || 1;
  return unitCents > 0 ? unitCents * qty : 0;
}

// Mirror von index.ts Z.39:
// Cents → deutsche EUR-Darstellung ("1.234,50 EUR"). Nicht-Zahl → "0,00 EUR".
export function centsToEur(c) {
  const v = Number(c) || 0;
  return (v / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' EUR';
}
